import { useIntl } from 'react-intl';
import { DictionaryEvidence, TableCells, TableColumn } from '@eas/common-web';
import { TechnicalObjectType } from '@models';

export function useColumns(): TableColumn<TechnicalObjectType>[] {
  const intl = useIntl();

  const dictionaryColumns =
    DictionaryEvidence.useDictionaryColumns<TechnicalObjectType>();

  return [
    dictionaryColumns.columnName,
    {
      datakey: 'voltageLevel.name',
      sortkey: 'voltageLevel.name',
      filterkey: 'voltageLevel.name',
      name: intl.formatMessage({
        id: 'ZSD__TECHNICAL_OBJECT_TYPE__TABLE__COLUMN__VOLTAGE_LEVEL',
        defaultMessage: 'Napätie',
      }),
      sortable: true,
      filterable: true,
      CellComponent: TableCells.TextCell,
      width: 150,
    },
  ];
}
